export type CreateAlbumWizardAlbumType = 'private' | 'public' | 'paid';

/** Payload aligned with Feed / AlbumsListPage / POST /api/albums/create */
export interface CreateAlbumFormPayload {
   title: string;
   description?: string;
   type: CreateAlbumWizardAlbumType;
   enableParticipantParticipation: boolean;
   pricePerPhoto?: number;
   pricingModel?: 'per_photo' | 'one_time' | 'donation';
   paidAlbumAccessType?: 'public' | 'private';
   albumDate?: string;
}

export interface SerializedCreateAlbumWizardState {
   activeStep: number;
   selectedType: CreateAlbumWizardAlbumType | null;
   title: string;
   description: string;
   albumDate: string;
   enableParticipantParticipation: boolean;
   pricePerPhoto: string;
   pricingModel: 'per_photo' | 'one_time' | 'donation';
   paidAlbumAccessType: 'public' | 'private';
}

export const DEFAULT_WIZARD_SERIALIZED: SerializedCreateAlbumWizardState = {
   activeStep: 0,
   selectedType: null,
   title: '',
   description: '',
   albumDate: '',
   enableParticipantParticipation: true,
   pricePerPhoto: '5.00',
   pricingModel: 'per_photo',
   paidAlbumAccessType: 'public',
};

/** Restore wizard fields from a saved payload (e.g. user went back from account step). */
export function payloadToSerializedWizard(
   p: CreateAlbumFormPayload
): SerializedCreateAlbumWizardState {
   return {
      activeStep: 2,
      selectedType: p.type,
      title: p.title,
      description: p.description || '',
      albumDate: p.albumDate || '',
      enableParticipantParticipation: p.enableParticipantParticipation,
      pricePerPhoto: String(p.pricePerPhoto ?? '5.00'),
      pricingModel: p.pricingModel || 'per_photo',
      paidAlbumAccessType: p.paidAlbumAccessType || 'public',
   };
}
